/* Vision Affichage — trajet du lead sans accroc.
   1) Desamorce le renvoi force vers l accueil quand le visiteur n a pas
      encore de logo (il arrive souvent d une publicite).
   2) Detourne "Changer de logo" / "Importer un nouveau logo" pour ouvrir
      la boite de depot au lieu de quitter la page.
   Aucune pastille, aucune barre : le depot du logo vit maintenant DANS
   la fenetre du configurateur (bouton "+ Logo" a cote des vignettes). */
(function(){
  var CLE="va_logo",SANS="va_sans_logo";
  function lire(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function poser(k,v){try{localStorage.setItem(k,v);return true}catch(e){return false}}
  function aLogo(){var v=lire(CLE);return !!(v&&v.length>20)}
  function surConfig(){return /\/pages\/commander/.test(location.pathname)}
  if(surConfig()&&!aLogo()&&lire(SANS)!=="1"){poser(SANS,"1")}
  function texteDe(el){
    var n=el,i=0;
    while(n&&i<4){var t=(n.textContent||"").trim();if(t&&t.length<40)return t;n=n.parentElement;i++}
    return "";
  }
  document.addEventListener("click",function(e){
    var el=e.target&&e.target.closest?e.target.closest("button,a"):null;
    if(!el)return;
    var t=texteDe(el);
    if(!/^Changer de logo$/i.test(t)&&!/^Importer un nouveau logo$/i.test(t))return;
    if(!window.__vaLogoAjout)return;
    e.preventDefault();e.stopPropagation();
    if(e.stopImmediatePropagation)e.stopImmediatePropagation();
    window.__vaLogoAjout(function(){
      if(!document.querySelector('[aria-modal="true"]'))setTimeout(function(){location.reload()},400);
    });
  },true);
})();